/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file
import './scss/frontend.scss';

import { Collapse, Dropdown } from 'bootstrap';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('[data-fancybox]');

document.querySelectorAll('a[target=_blank]').forEach((a) => {
  const rel = a.rel ? a.rel.split(' ') : [];

  if (rel.includes('noopener')) {
    return;
  }

  rel.push('noopener');

  a.rel = rel.join(' ');
});
